import axios from "axios";

import { config } from "../../config";
import { portalAccessPrefixV1 } from "../../paths";

const END_POINT: string = `${portalAccessPrefixV1}/consumerAuthorized`;

type ConsumerPortalAccessResponse = {
  isAuthorized: boolean;
  rewardsAccounts: unknown[];
};

export const fetchCanAccessConsumer = async (): Promise<boolean> => {
  try {
    const res = await axios.put(
      END_POINT,
      {},
      {
        baseURL: config.baseURL,
      }
    );

    const data = res.data as Partial<ConsumerPortalAccessResponse>;

    if (
      typeof data?.isAuthorized !== "boolean" ||
      !Array.isArray(data?.rewardsAccounts)
    ) {
      throw new Error("Unexpected consumerAuthorized response");
    }

    return data.isAuthorized;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 403) {
      return false;
    }

    throw error;
  }
};
